import React from "react";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import loader from "../../../../assets/images/button-loader.svg"
import { useParams } from "react-router-dom";
import WebService from "../../../../utility/WebService";
import SucessModal from "../../../../components/SucessModal/Sucess";
import WarningModal from "../../../../components/Warning/Warning";
import Loader from "../../../../components/Loader/Loader";
import { Label } from "../../../../components/Label/Label";
import { BsQuestionCircle } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import HelperService from "../../../../utility/HelperService";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../../components/Grid/Grid";
import { useNavigate } from "react-router-dom";
import BackComponent from "../../../../components/BackArrow";



const headers: GridHeader[] = [
    {
        title: "Compalints Id",
        classTitle: 'text-start'
    },
    {
        title: "Received From",
        class: 'text-center'
    },
    {
        title: "Received Date",
        class: 'text-center'
    },
    {
        title: "Status",
        class: 'text-center'
    },
    {
        title: "Status Date",
        class: 'text-center'
    },
    {
        title: "Actions",
        class: "text-center"
    },



];
const ComplaintsCount = () => {
    const {
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();
    const [isLoading, setLoading] = useState(false);
    const [ShowLoader, setShowLoader] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [previousData, setpreviousData] = useState("");
    const [editorData, setEditorData] = useState<any>()
    const [rows, setRows] = useState<GridRow[]>([]);
    const [totalCount, setTotalCount] = useState("");

    let { id } = useParams();
    let { month } = useParams();

    let history = useNavigate();
    useEffect(() => {
        getList(1,'');
    }, []);
    // console.log(id);
    const getList = (page: Number, searchText: string) => {
        setShowLoader(true);
        WebService.getAPI({
            action: `/v2/Complaints/GetComplaintscountList?page=${page}&keyword=${searchText}&month=${month}`,
        })
            .then((res: any) => {
               
                setTotalCount(res.total_count);
                setShowLoader(false);
                let rows: GridRow[] = [];
                for (var i in res.list) {
                   
                    let columns: GridColumn[] = [];
                    columns.push({ value: res.list[i].complaint_id ? res.list[i].complaint_id   : "-" });
                    columns.push({ value: res.list[i].received_from? res.list[i].received_from  : "-" });
                    columns.push({ value: res.list[i].received_date? HelperService.getFormatedDateByDMYwith(res.list[i].received_date) : "-" });
                    columns.push({ value: res.list[i].status ? res.list[i].status   : "-" });
                    columns.push({ value: res.list[i].status_date ?HelperService.getFormatedDateByDMYwith(res.list[i].status_date) : "-" });
                   columns.push({ value: actionList(res.list[i].id) });
                //    console.log(res.list[i].month);
                    rows.push({ data: columns });
                }
                setRows(rows);
            })
            .catch(() => {
                setShowLoader(false);
            });
    };
    const actionList = (value: Number) => {
        return (
            <>
                <a onClick={() => history(`/edit-complaint/${value}`, {
                   
                })} className="action-btn cursor-pointer" title="Edit">
                    <svg className="icon inline mr-2" width={18} height={18} >
                        <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#edit"></use>
                    </svg>
                </a>
              

            </>
        );
    };
    const onDelete = (data: any) => {
        //setShowDeleteModal(true);
        var obj = {
            id: data,
        };
        //setDeletedData(obj);
    };
    const onSorting = (currentPage: number, searchText: string) => {
        getList(currentPage, searchText)
    }

    const currentValue = (data: any) => {
        setEditorData(data)
    };

    const goBack = () => {
        window.history.back();
    };

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setShowLoader(false);
    }

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setLoading(false);
    }

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />

            <Loader show={ShowLoader} />
            <div className="page-content-wraper">
                <div className="grid grid-cols-2 gap-4 mb-3">
                <div className="grid grid-cols-2 gap-4 mb-3">
                    <div>
                        {" "}
                        <BackComponent
                        title={"Complaints"}
                        />
                    </div>
                   
                </div>
                   
                    <div className="text-right flex justify-end items-center">
                        <button type="button" className="btn bg-white px-3 py-1 rounded-md hover:shadow-xl  shadow-sm mr-3" title="Help">
                            <BsQuestionCircle size={20} className="inline mr-1" /> Help
                        </button>
                    </div>
                </div>

                <div className="table-card">
                    <Grid
                        headers={headers}
                        rows={rows}
                        ShowLoader={ShowLoader}
                        errorMessage={"No Complaints Found"}
                        count={totalCount}
                        onPageChange={onSorting}
                        isShowSearch={true}
                    />
                </div>
            </div>

        </>
    )
}
export default ComplaintsCount;





